<template>
    <div class="v-select-mobile">
      <div class="v-select-mobile__input">
        <input
          ref="vSelectInputMobile"
          type="text"
          :placeholder="placeholder"
          v-model="value"
          @input="onInput($event)"
        />
      </div>
      <div v-if="icon" class="v-select-mobile__icon">
        <v-icon name="caret" />
      </div>
      <div
        class="v-select-mobile__close"
        @mousedown.prevent.stop="closeFullscreen()"
      >
        {{ $t('Luk', 'components.searchable-select.close') }}
    </div>
    <div class="v-select-mobile__slot">
      <slot></slot>
    </div>
    <v-icon
      v-if="!fetching && value || !fetching && active"
      name="x" 
      width="10"
      @click.native="resetInput()"
      class="v-select-mobile__icon"
    />
    <div v-if="fetching" class="v-select-mobile__spinner">
      <v-loading small />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "Vælg én"
    },
    icon: {
      type: String,
      default: null
    },
    active: {
      type: String,
      default: null
    },
    fetching: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: ""
    };
  },
  mounted() {
    this.$refs.vSelectInputMobile.focus();
    // check if child is same as active and then set active class
    if (this.active) {
      this.$children[0].$children.forEach(child => {
        if (child.$el.innerText === this.active) {
          child.$el.classList.add("v-select__option--active");
        }
      });
    }
  },
  computed: {},
  methods: {
    resetInput() {
      this.value = "";
      this.$emit("resetInput");
      this.$refs.vSelectInputMobile.focus();
    },
    closeFullscreen() {
      this.$emit("closeFullscreen");
    },
    onInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/component.scss";

.v-select-mobile {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 1000;
  transition: border-color 0.1s ease-in-out;

  &__input {
    min-height: 44px;
    padding: 20px 90px 16px 16px;
    border: 0;
    border-radius: initial;
    border-bottom: 1px solid #f2f2f4;
    width: 100%;

    & input {
      width: 100%;
      margin-right: 1rem;
      font-size: 1rem;
      font-weight: 400;
      color: #333;
      border: none;
      outline: none;
      background-color: transparent;
      cursor: pointer;
    }
  }

  &__icon {
    position: absolute;
    right: 3rem;
    top: 1.25rem;
    cursor: pointer;
    color: theme-color("white");
    background-color: theme-color("border");
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    z-index: 50;
    cursor: pointer;
  }

  &__close {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    padding: 17px 15px 10px 10px;
    color: theme-color("primary");
  }
  &__spinner {
    position: absolute;
    right: 3rem;
    top: 1.3rem;
    z-index: 51;
  }
}
</style>
